/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { persistor } from '../../store';

function StaleClientModal() {
  const dispatch = useDispatch();
  const { staleClientModal } = useSelector(store => store.modals);

  function update() {
    dispatch({ type: 'SET_MODAL', payload: { staleClientModal: false } });
    dispatch({ type: 'SHOW_RELEASE_NOTES' });
    dispatch({ type: 'REFRESH_RELEASE_NOTES' });
    persistor.flush().then(() => {
      window.location.reload(true);
    });
  }

  /*
  useEffect(() => {
    if (staleClientModal && window.location.pathname === '/') {
      update();
    }
  }, [staleClientModal]);
  */

  return staleClientModal
    ? (
      <div
        className={[
          'position-fixed d-flex d-print-none',
          'p-3 ps-4 pe-4',
          'bg-white shadow-sm border align-items-center',
        ].join(' ')}
        style={{ right: '25px', bottom: '25px', zIndex: 9999 }}
        onClick={update}
        role="button"
        tabIndex={0}
      >
        <span className="btn p-0 pe-2">A new version of MyMedicareBot is available</span>
        <div
          className="font-weight-bold btn btn-primary text-white"
        >
          Update now
        </div>
      </div>
    ) : null;
}
export default StaleClientModal;
